
    <template>
    <svg viewBox="0 0 13 13" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.29169 0.583252C9.67444 0.583252 12.4167 3.3255 12.4167 6.70825C12.4167 10.091 9.67444 12.8333 6.29169 12.8333C2.90894 12.8333 0.166687 10.091 0.166687 6.70825C0.166687 3.3255 2.90894 0.583252 6.29169 0.583252ZM6.72919 2.77075H5.85419V6.70825C5.85419 6.80485 5.88555 6.89417 5.93865 6.9668L5.9824 7.018L8.60734 9.64259L9.22603 9.02391L6.72919 6.52713V2.77075Z"
    fill="currentColor"
  />
</svg>

    </template>

    <script lang="ts">
    import type { DefineComponent } from 'vue'
    export default ({
      name: 'ClockFill',
    }) as DefineComponent
    </script>
    